<template>
    <div class="check-box-block"  :class="{'close': !open }">
        <div class="check-box-block-title">
            <checkbox :msg="title" :val="open" v-model="open" :isPropChecked="open"></checkbox>
        </div>
        <div class="check-box-block-body">
            <slot name="check-box-block-sub-title"></slot>
            <slot name="check-box-block-body"></slot>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
export default {
    data () {
        return {
            arrowImg: require('@/assets/img/icon/arrow_up_orange.svg'),
            arrowRotate: '0',
            open: this.isOpen
        }
    },
    props:{
        isOpen: {
            default: false,
            type: Boolean
        },
        title: String
    },
    watch: {
        open: {
            handler: function (val) {
                this.$emit('input', val)
            },
            immediate: true
        }
    },
    methods: {
    },
    components: {
        Checkbox
    }
}
</script>
<style lang="scss"  >
    .check-box-block{
        position: relative;
        width: 1140px;
        border-radius: 6px;
        border: solid 1px #f3f3f3;
        background-color: #ffffff;
        box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
        margin-bottom: 20px;
        >.check-box-block-title{
            padding: 24px;
        }
        >.check-box-block-body{
            padding: 0 24px 24px 24px;
            >.check-box-block-sub-title{
                display: flex;
                align-items: center;
                font-size: 20px;
                color: #ff9275;
                margin-bottom: 24px;
            }
        }
    }
    .check-box-block.close{
        .check-box-block-body{
            display: none;
        }
    }
    @media screen and (max-width: 1280px) {
        .check-box-block{
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tools/checkBoxBlock.vue